module.exports = __webpack_public_path__ + "static/decorator-lazy-loading.b24ef893.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/homepage/decorator-lazy-loading.png
// module id = 2544
// module chunks = 35783957827783